module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (3).879d779e.svg";